/* eslint-disable react/prop-types */
import { useEffect } from "react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import Heading from "../../components/Heading";
import { getCategory } from "../../redux/features/CategorySlice";

const NextArrow = ({ onClick }) => (
  <div
    className="absolute z-10 flex items-center justify-center w-12 h-12 text-white transform -translate-y-1/2 bg-black opacity-50 cursor-pointer top-1/2 -right-8"
    onClick={onClick}
  >
    <IoIosArrowForward size={30} />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div
    className="absolute z-10 flex items-center justify-center w-12 h-12 text-white transform -translate-y-1/2 bg-black opacity-50 cursor-pointer top-1/2 -left-8"
    onClick={onClick}
  >
    <IoIosArrowBack size={30} />
  </div>
);

const MainCategories = ({ slug }) => {
  const categories = useSelector((state) => state.maincategory.categories);
  const subcategories = useSelector(
    (state) => state.maincategory.subcategories
  );
  const id = categories?.find(
    (category) =>
      category?.slug.toLowerCase() === slug ||
      category?.slug.toLowerCase() === slug?.slice(0, -1)
  )?.id;

  // Filter categories to include only those with parent name "Mens"
  const filteredCategories =
    categories?.filter((category) => category?.parent_id === id) || [];

  const dispatch = useDispatch();
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          infinite: true,
        },
      },
    ],
  };

  useEffect(() => {
    const filter = {
      "parent.slug": {
        $eq: slug,
      },
    };
    dispatch(getCategory({ populate: "parent,image", name: slug, filter }));
  }, [dispatch, slug]);

  return (
    <div className="container pt-12 text-center">
      <Heading title={"Categories"} />

      {/* Conditionally render flex or slider based on subcategories length */}
      {subcategories?.length < 3 ? (
        // Flex layout for less than 3 subcategories
        <div className="flex justify-start gap-4">
          {subcategories?.map((category, index) => (
            <Link to={category?.slug} key={index}>
              <div className="h-[10rem] w-[10rem]">
                <img
                  src={
                    category?.image?.url ||
                    "https://wpecomus.com/furniture/wp-content/uploads/sites/11/2024/06/p-decor-034.webp"
                  }
                  className="w-full h-full"
                  alt={category?.name}
                />
                <p className="">{category?.name}</p>
              </div>
            </Link>
          ))}
        </div>
      ) : (
        // Slider for 3 or more subcategories
        <div
          className="slider-container"
          style={{ width: "100%", maxWidth: "800px" }}
        >
          <Slider {...settings}>
            {subcategories?.map((category, index) => (
              <Link to={category?.slug} key={index}>
                <div className="mx-3 h-[10rem] w-[10rem]">
                  <img
                    src={
                      // category?.image?.url ||
                      "https://wpecomus.com/furniture/wp-content/uploads/sites/11/2024/06/p-decor-034.webp"
                    }
                    className="w-full h-full"
                    alt={category?.name}
                  />
                  <p className="">{category?.name}</p>
                </div>
              </Link>
            ))}
          </Slider>
        </div>
      )}
    </div>
  );
};

export default MainCategories;
